<template>
	<div>
		<Layout>
			<div class="container box_general">
				<div class="header_box">
					<h2><i class="pe-7s-user"></i>Mi perfil</h2>
				</div>
				<div class="row">
					<div class="col">
						<PharmacyForm v-if="loggedPharmacy" :id="loggedPharmacy.id" @updated="upserted" @created="upserted" />

						<br />
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

import Layout from "@/components/layout/Layout"
import PharmacyForm from "./PharmacyForm"

export default {
	name: "ProfileUpdate",
	components: {
		Layout,
		PharmacyForm
	},
	computed: {
		...mapGetters(["isAuthenticated", "loggedPharmacy"])
	},
	data() {
		return {}
	},
	methods: {
		upserted(data) {
			this.$router.go(-1)
		}
	}
}
</script>

<style scoped></style>
